import * as Sentry from '@sentry/react';
import Userback, { type UserbackWidget } from '@userback/widget';
import { USERBACK_ID } from '@/base/constants';

let userbackPromise: Promise<UserbackWidget | null> | null = null;

export const initiateUserback = () => {
  if (!userbackPromise) {
    userbackPromise = USERBACK_ID
      ? Userback(USERBACK_ID, {
          widget_settings: {
            position: 'se',
            language: 'en',
            logo: '/logo.svg',
            trigger_type: 'page_load',
          },
        }).catch((err) => {
          Sentry.captureException(err, {
            extra: {
              message: 'Failed to load Userback widget',
            },
          });
          return null;
        })
      : Promise.reject();
    (window as any).userbackPromise = userbackPromise;
    (window as any).userbackId = USERBACK_ID;
  }
  return userbackPromise;
};
